// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"17fe6e42","328":"031c93b4","430":"031c93b4","655":"17fe6e42"}[chunkId] + ".chunk.css";
};